import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = () => {
  const [selectedMethod, setSelectedMethod] = useState('phone');

  const contactMethods = [
    {
      id: 'phone',
      icon: 'Phone',
      title: 'Phone Support',
      description: 'Speak directly with our fabric experts',
      primary: '+91 99740 56700',
      secondary: '+91 99740 56700',
      action: 'Call Now',
      available: '9:00 AM - 7:00 PM IST',
      color: 'text-primary'
    },
    {
      id: 'whatsapp',
      icon: 'MessageCircle',
      title: 'WhatsApp Business',
      description: 'Quick responses and file sharing',
      primary: '+91 99740 56700',
      secondary: 'Business Account Verified',
      action: 'Chat Now',
      available: '24/7 Quick Response',
      color: 'text-green-600'
    },
    {
      id: 'email',
      icon: 'Mail',
      title: 'Email Support',
      description: 'Detailed inquiries and documentation',
      primary: 'info@kunjvihariimpex.com',
      secondary: 'jenish.padariya@kunjvihariimpex.com',
      action: 'Send Email',
      available: 'Response within 2 hours',
      color: 'text-textile'
    },
    {
      id: 'visit',
      icon: 'MapPin',
      title: 'Factory Visit',
      description: 'See our fabric manufacturing firsthand',
      primary: 'Schedule a Tour',
      secondary: 'Surat, Gujarat',
      action: 'Book Visit',
      available: 'Mon-Sat 9:00 AM - 7:00 PM',
      color: 'text-secondary'
    }
  ];

  const handleMethodSelect = (methodId) => {
    setSelectedMethod(methodId);
  };

  const handleAction = (method) => {
    switch (method?.id) {
      case 'phone':
        window.open(`tel:${method?.primary?.replace(/\s/g, '')}`);
        break;
      case 'whatsapp':
        window.open(`https://wa.me/${method?.primary?.replace(/\D/g, '')}`);
        break;
      case 'email':
        window.open(`mailto:${method?.primary}`);
        break;
      case 'visit':
        // Scroll to appointment section
        document.getElementById('appointment-section')?.scrollIntoView({ behavior: 'smooth' });
        break;
      default:
        break;
    }
  };

  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-poppins font-bold text-text-primary mb-2 sm:mb-3 lg:mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-text-secondary max-w-2xl mx-auto px-2">
            We offer multiple ways to connect with our team. Select the method that works best for you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 mb-6 sm:mb-8 lg:mb-12">
          {contactMethods?.map((method) => (
            <div
              key={method?.id}
              className={`card-elevated p-4 sm:p-5 lg:p-6 cursor-pointer transition-all duration-300 ${
                selectedMethod === method?.id
                  ? 'ring-2 ring-primary bg-primary/5' :'hover:shadow-xl'
              }`}
              onClick={() => handleMethodSelect(method?.id)}
            >
              <div className="text-center">
                <div className={`inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-full bg-gradient-to-br from-primary/10 to-secondary/10 mb-3 sm:mb-4 ${method?.color}`}>
                  <Icon name={method?.icon} size={24} className="sm:w-7 sm:h-7 lg:w-8 lg:h-8" />
                </div>
                
                <h3 className="text-base sm:text-lg lg:text-xl font-poppins font-semibold text-text-primary mb-1.5 sm:mb-2">
                  {method?.title}
                </h3>
                
                <p className="text-text-secondary mb-3 sm:mb-4 text-xs sm:text-sm leading-relaxed">
                  {method?.description}
                </p>
                
                <div className="space-y-1 sm:space-y-2 mb-3 sm:mb-4">
                  <p className="text-sm sm:text-base font-medium text-text-primary break-words">
                    {method?.primary}
                  </p>
                  <p className="text-xs sm:text-sm text-text-secondary">
                    {method?.secondary}
                  </p>
                </div>
                
                <div className="text-[10px] sm:text-xs text-golden font-medium mb-3 sm:mb-4">
                  {method?.available}
                </div>
                
                <Button
                  variant={selectedMethod === method?.id ? 'default' : 'outline'}
                  size="sm"
                  fullWidth
                  className="text-xs sm:text-sm font-semibold"
                  onClick={(e) => {
                    e?.stopPropagation();
                    handleAction(method);
                  }}
                  iconName={method?.icon}
                  iconPosition="left"
                  iconSize={14}
                >
                  {method?.action}
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Business Hours */}
        <div className="bg-white rounded-lg shadow-textile p-4 sm:p-5 lg:p-6">
          <div className="flex items-center justify-center mb-3 sm:mb-4">
            <Icon name="Clock" size={20} className="text-primary mr-2 sm:w-6 sm:h-6" />
            <h3 className="text-base sm:text-lg lg:text-xl font-poppins font-semibold text-text-primary">
              Business Hours (IST)
            </h3>
          </div>
          
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm sm:text-base font-medium text-text-primary">Monday - Saturday</span>
              <span className="text-sm sm:text-base text-primary font-semibold">9:00 AM - 7:00 PM</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm sm:text-base font-medium text-text-primary">Sunday</span>
              <span className="text-sm sm:text-base text-text-secondary">Closed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;